import { Grid, GridColumn } from "@progress/kendo-react-grid";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  CreateEntryTemplateButton,
  EditDatasetButton,
  EditEntryButton,
  EditTemplateButton,
  ViewDatasetButton,
  ViewEntryLink,
  ViewEntryTemplateButton,
  ViewTemplateButton,
} from "../Buttons/HomepageButtons";
import { allTemplates } from "../Common/Store/CommonSignals";
import "./Homepage.css";

export const EntryLink = () => {
  const navigate = useNavigate();
  return (
    <div className="navContainer">
      <button
        className="entryButton"
        onClick={() => navigate("/view-entry")}
      >
        View Entries
      </button>
    </div>
  );
};

export const TemplateLinks = () => {
  const navigate = useNavigate();
  return (
    <div className="navContainer">
      <button
        className="navButtons"
        onClick={() => navigate("/templates/create")}
      >
        New Template
      </button>
      <button
        className="navButtons"
        onClick={() => navigate("/templates")}
      >
        View Templates
      </button>
    </div>
  );
};

export const DatasetLinks = () => {
  const navigate = useNavigate();
  return (
    <div className="navContainer">
      <button
        className="navButtons"
        onClick={() => navigate("/datasets/create")}
      >
        New Dataset
      </button>
      <button
        className="navButtons"
        onClick={() => navigate("/datasets")}
      >
        View Datasets
      </button>
    </div>
  );
};

const renderDatasetButton = (props) => (
  <td>
    <div className="align-columns">
      <EditDatasetButton {...props} />
      <ViewDatasetButton {...props} />
    </div>
  </td>
);

const renderTemplateButton = (props) => (
  <td>
    <div className="align-columns">
      <ViewEntryTemplateButton {...props} />
      <CreateEntryTemplateButton {...props} />
      <EditTemplateButton {...props} />
      <div className="viewContainer">
        <ViewTemplateButton {...props} />
      </div>
    </div>
  </td>
);

const renderEntryButton = (props) => (
  <td>
    <div className="align-columns">
      <EditEntryButton {...props} />
    </div>
  </td>
);

const renderEntryDate = (event) => {
  const date = new Date(event.dataItem._ts * 1000);

  const options = {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };

  const formattedDate = date.toLocaleDateString("en-US", options);

  return <td title={formattedDate}>{formattedDate}</td>;
};

const renderTemplateName = (event) => {
  const tempName = allTemplates.value?.map((template) => {
    if (event.dataItem.templateId === template.id) {
      return template.templateName;
    }
  });
  return <td title={tempName}>{tempName}</td>;
};

export const PermissionTemplateGrid = (props) => {
  const [skip, setSkip] = React.useState(0);
  const pageSize = 25;
  const pageChange = (event) => {
    setSkip(event.page.skip);
  };
  return (
    <div className="gridContainer">
      <div className="gridHeaderBG">
        <p className="gridHeader"> {"Shared Templates"}</p>
      </div>
      <div className="gridBodyBG">
        <Grid
          className="gridStyle"
          style={{
            height: "85%",
            width: "100%",
          }}
          rowHeight={61.84}
          data={props.tables}
          pageSize={pageSize}
          total={props.tables.length}
          skip={skip}
          scrollable={"virtual"}
          onPageChange={pageChange}
        >
          <GridColumn
            field="templateName"
            title="Template Name"
            cells={{
              data: ViewEntryLink,
            }}
          />
          <GridColumn
            field="company"
            title="Company"
            className="!k-white-space-normal"
          />
          <GridColumn
            field="area"
            title="Area"
            className="!k-white-space-normal"
          />
          <GridColumn
            field="department"
            title="Department"
            className="!k-white-space-normal"
          />
          <GridColumn
            title="User Permission"
            field="permission"
            className="!k-white-space-normal"
          />
          <GridColumn
            cells={{
              data: (event) => renderTemplateButton(event),
            }}
          />
        </Grid>
      </div>
    </div>
  );
};

export const OwnerTemplateGrid = (props) => {
  const [skip, setSkip] = React.useState(0);
  const pageSize = 25;
  const pageChange = (event) => {
    setSkip(event.page.skip);
  };
  return (
    <div className="gridContainer">
      <div className="gridHeaderBG">
        <p className="gridHeader"> {"My Templates"}</p>
      </div>
      <div className="gridBodyBG">
        <Grid
          className="gridStyle"
          style={{
            height: "85%",
            width: "100%",
          }}
          rowHeight={61.84}
          data={props.tables}
          pageSize={pageSize}
          total={props.tables.length}
          skip={skip}
          scrollable={"virtual"}
          onPageChange={pageChange}
        >
          <GridColumn
            field="templateName"
            title="Template Name"
            cells={{
              data: ViewEntryLink,
            }}
          />
          <GridColumn
            field="company"
            title="Company"
            className="!k-white-space-normal"
          />
          <GridColumn
            field="area"
            title="Area"
            className="!k-white-space-normal"
          />
          <GridColumn
            field="department"
            title="Department"
            className="!k-white-space-normal"
          />
          <GridColumn
            title="User Permission"
            field="permission"
            className="!k-white-space-normal"
          />
          <GridColumn
            cells={{
              data: (event) => renderTemplateButton(event),
            }}
          />
        </Grid>
      </div>
    </div>
  );
};

export const DatasetGrid = (props) => {
  const [skip, setSkip] = React.useState(0);
  const pageSize = 25;
  const pageChange = (event) => {
    setSkip(event.page.skip);
  };
  return (
    <div className="gridContainer bottomGrid">
      <div className="gridHeaderBG">
        <p className="gridHeader">Datasets</p>
      </div>
      <div className="gridBodyBG">
        <Grid
          className="gridStyle"
          style={{
            height: "85%",
            width: "100%",
          }}
          rowHeight={61.84}
          data={props.tables}
          pageSize={pageSize}
          total={props.tables.length}
          skip={skip}
          scrollable={"virtual"}
          onPageChange={pageChange}
          he
        >
          <GridColumn
            field="datasetName"
            title="Dataset Name"
            className="!k-white-space-normal"
          />
          <GridColumn
            field="datasetType"
            title="Dataset Type"
            className="!k-white-space-normal"
          />
          <GridColumn
            title="User Permission"
            field="permission"
            className="!k-white-space-normal"
          />
          <GridColumn
            cells={{
              data: (event) => renderDatasetButton(event),
            }}
          />
        </Grid>
      </div>
    </div>
  );
};

export const EntryGrid = (props) => {
  const [skip, setSkip] = React.useState(0);
  const pageSize = 25;
  const pageChange = (event) => {
    setSkip(event.page.skip);
  };
  return (
    <div className="gridContainer bottomGrid">
      <div className="gridHeaderBG">
        <p className="gridHeader"> {"Most Recent Entries"}</p>
      </div>
      <div className="gridBodyBG">
        <Grid
          className="gridStyle"
          style={{
            height: "85%",
            width: "100%",
          }}
          rowHeight={61.84}
          data={props.tables}
          pageSize={pageSize}
          total={props.tables.length}
          skip={skip}
          scrollable={"virtual"}
          onPageChange={pageChange}
        >
          <GridColumn
            field="_ts"
            title="Date Created"
            cells={{
              data: renderEntryDate,
            }}
          />
          <GridColumn
            field="templateId"
            title="Template Name"
            cells={{
              data: renderTemplateName,
            }}
          />
          <GridColumn
            cells={{
              data: renderEntryButton,
            }}
          />
        </Grid>
      </div>
    </div>
  );
};
